import * as _ from 'lodash';

export interface ValidationExceptionResponse {
    status: number;
    timestamp: number;
    message: string;
    tags: string[];
}

async function simpleBackendRequest(
    url: string,
    request: RequestInit
): Promise<Response> {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const options = _.defaultsDeep({}, request, { headers });
    return await fetch(url, options);
}

export default simpleBackendRequest;
